import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, UrlTree, Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class ParamsGuard {

  private readonly router = inject(Router);

  canActivate(
    next: ActivatedRouteSnapshot
  ): boolean | UrlTree {
    const params = next.params;
    const uuidPattern = /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/;

    if (params?.['token'] && uuidPattern.test(params['token'])) {
      return true;
    } else {
      return this.router.createUrlTree([ '/error' ]);
    }
  }
}
